import { Button, ButtonProps, Icon, useDisclosure } from "@chakra-ui/react";
import { RiFilter2Line } from "@remixicon/react";
import { useEffect, useState } from "react";
import { SelectOption } from "../../constants/SelectOption";
import useCustomToast from "../../lib/useCustomToast";
import { axiosPublic } from "../../utils/AxiosInstance";
import { DrawerList } from "../drawer/DrawerList";

interface Props extends ButtonProps {
  onConfirm: (select: SelectOption | undefined) => void;
  title?: string;
}

export const FilterButton = ({
  onConfirm,
  title = "Filter",
  ...rest
}: Props) => {
  const [data, setData] = useState<SelectOption[] | undefined>(undefined);
  const [selectedFilter, setSelectedFilter] = useState<string>("");

  const [loaded, setLoaded] = useState<boolean>(false);

  const { isOpen, onOpen, onClose } = useDisclosure();
  const toast = useCustomToast();

  useEffect(() => {
    if (isOpen) {
      axiosPublic
        .get(`${process.env.REACT_APP_API_URL}/v1/masterdata/status-purchase`)
        .then((res) => {
          setData(res.data.data);
        })
        .catch((err) => {
          toast({
            description: err?.response?.data?.message || "",
          });
        })
        .finally(() => {
          setLoaded(true);
        });
    }
  }, [isOpen]);

  return (
    <>
      <Button
        className="btn-filter"
        variant={"ghost"}
        leftIcon={<Icon as={RiFilter2Line} />}
        onClick={onOpen}
        fontWeight={"normal"}
        {...rest}
      >
        {selectedFilter ? selectedFilter : title}
      </Button>

      <DrawerList
        isOpen={isOpen}
        onOpen={onOpen}
        onClose={onClose}
        data={data}
        loaded={loaded}
        title="Filter Pesanan"
        onSelectedList={(select) => {
          setSelectedFilter(select?.name || "");
          onConfirm(select);
        }}
        children={undefined}
      />
    </>
  );
};
